import type { ReactNode } from 'react';
import type { FormContextProps } from './formContext';
import type { IFormLabelProps } from './forms/FormLabel';
import type { IHorizontalFormGroupProps } from './forms/HorizontalFormGroup';
import type { IInputContainerProps } from './forms/InputContainer';
import { FormContextConsumer } from './formContext';
import { FormLabel } from './forms/FormLabel';
import { HorizontalFormGroup } from './forms/HorizontalFormGroup';
import { InputContainer } from './forms/InputContainer';

type IFormFieldProps = {
    children: ReactNode;
    label: string;
} & IHorizontalFormGroupProps &
    IFormLabelProps &
    IInputContainerProps;
export type IFieldProps = Omit<IFormFieldProps, 'children'>;

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function Field(props: FormContextProps<IFormFieldProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => {
                return (
                    <HorizontalFormGroup {...properties}>
                        {properties.label && <FormLabel {...properties}>{properties.label}</FormLabel>}
                        <InputContainer {...properties}>{props.children}</InputContainer>
                    </HorizontalFormGroup>
                );
            }}
        </FormContextConsumer>
    );
}
